<template>
  <v-app id="app" style="height:100%;" @keydown.a="test">
    <v-navigation-drawer
      v-model="visible"
      :clipped="true"
      :floating="false"
      :mini-variant="false"
      :permanent="false"
      :temporary="false"
      app
      overflow
    >
      <v-list>
        <v-list-item link @click="del.open = true">
          <v-list-item-icon>
            <v-icon>far fa-trash</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Ergebnisse löschen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="true"
      app
      dense
    >
      <v-app-bar-nav-icon
        @click.stop="visible = !visible"
      ></v-app-bar-nav-icon>
      <v-toolbar-title><img src="../public/svv.png" style="height:30px; float:left; margin-right: 12px;"/>Ninja-Parcours</v-toolbar-title>
      <div class="flex-grow-1"></div>
      Anzahl Fenster:&nbsp;&nbsp;
      <v-btn small fab :text="anzahl!==1" @click="$store.commit('setanzahl',1)">1</v-btn>
      <v-btn small fab :text="anzahl!==2" @click="$store.commit('setanzahl',2)">2</v-btn>
      <v-btn small fab :text="anzahl!==4" @click="$store.commit('setanzahl',4)">4</v-btn>
      <div class="flex-grow-1"></div>
      <v-btn small fab text ripple @click="maximize" v-if="!maximized"><v-icon>far fa-expand</v-icon></v-btn>
      <v-btn small fab text ripple @click="minimize" v-else><v-icon>far fa-compress</v-icon></v-btn>
    </v-app-bar>

    <v-content dark style="height:100%;">
      <router-view/>
    </v-content>

    <v-footer app>
      <div class="flex-grow-1"></div>
      <div>&copy; {{ new Date().getFullYear() }}, IT Kimmig</div>
    </v-footer>

    <v-dialog v-model="del.open" @keydown.esc="del.open = false" persistent width="400">
      <v-card flat>
        <v-card-title><v-icon class="mr-5">far fa-trash</v-icon>Wirklich alles löschen?</v-card-title>
        <v-card-actions>
          <v-btn @click="() => {del.open = false; $store.commit('del')}" class="red lighten-2">Ja</v-btn>
          <div class="flex-grow-1" />
          <v-btn @click="del.open = false" class="green lighten-2">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    visible: false,
    maximized: false,
    del: {
      open: false
    }
  }),
  computed: {
    anzahl: {
      get () {
        return this.$store.state.anzahl
      },
      set (v) {
        this.$store.state.anzahl = v
      }
    }
  },
  methods: {
    maximize () {
      const elem = document.getElementById('app')

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }

      this.maximized = true
    },
    minimize () {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }

      this.maximized = false
    }
  }
}
</script>

<style lang="scss">
  @import './less/reset.css';
  @import './less/main.scss';
</style>
